var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",class:_vm.platform},[_c('Header1',{attrs:{"extras":_vm.extras}}),_c('Banner',{attrs:{"extras":_vm.extras}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }